import OliverText from "@builder/components/general/OliverText";
import OliverImage from "../../app/OliverImage";
import UnitInput from "../UnitInput";
import "./style.scss";
import { useTranslation } from "react-i18next";

export type BorderRadiusInit = {
    topLeft: { value: string; unit: string };
    topRight: { value: string; unit: string };
    bottomRight: { value: string; unit: string };
    bottomLeft: { value: string; unit: string };
};

interface BorderRadiusInputsProps {
    title?: string;
    init: BorderRadiusInit;
    callback: (values: BorderRadiusInit) => void;
}

const BorderRadiusInputs: React.FC<BorderRadiusInputsProps> = ({ title = "Radius", init, callback }: BorderRadiusInputsProps) => {
    const { t } = useTranslation();

    const topLeftCallback = (value: string, unit: string) => {
        callback({
            topLeft: { value: value, unit: unit },
            topRight: init.topRight.value ? init.topRight : { value: "0", unit: init.topRight.unit },
            bottomRight: init.bottomRight.value ? init.bottomRight : { value: "0", unit: init.bottomRight.unit },
            bottomLeft: init.bottomLeft.value ? init.bottomLeft : { value: "0", unit: init.bottomLeft.unit }
        });
    };
    const topRightCallback = (value: string, unit: string) => {
        callback({
            topLeft: init.topLeft.value ? init.topLeft : { value: "0", unit: init.topLeft.unit },
            topRight: { value: value, unit: unit },
            bottomRight: init.bottomRight.value ? init.bottomRight : { value: "0", unit: init.bottomRight.unit },
            bottomLeft: init.bottomLeft.value ? init.bottomLeft : { value: "0", unit: init.bottomLeft.unit }
        });
    };
    const bottomRightCallback = (value: string, unit: string) => {
        callback({
            topLeft: init.topLeft.value ? init.topLeft : { value: "0", unit: init.topLeft.unit },
            topRight: init.topRight.value ? init.topRight : { value: "0", unit: init.topRight.unit },
            bottomRight: { value: value, unit: unit },
            bottomLeft: init.bottomLeft.value ? init.bottomLeft : { value: "0", unit: init.bottomLeft.unit }
        });
    };
    const bottomLeftCallback = (value: string, unit: string) => {
        callback({
            topLeft: init.topLeft.value ? init.topLeft : { value: "0", unit: init.topLeft.unit },
            topRight: init.topRight.value ? init.topRight : { value: "0", unit: init.topRight.unit },
            bottomRight: init.bottomRight.value ? init.bottomRight : { value: "0", unit: init.bottomRight.unit },
            bottomLeft: { value: value, unit: unit }
        });
    };

    const handleApplyAll = () => {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLInputElement && activeElement?.classList.contains("value-input")) {
            const unitElement = activeElement.nextElementSibling?.querySelector("input");
            if (unitElement) {
                const newValue = { value: activeElement.value, unit: unitElement.value };
                callback({
                    topLeft: newValue,
                    topRight: newValue,
                    bottomRight: newValue,
                    bottomLeft: newValue
                });
            }
        }
    };

    return (
        <div className="border-radius-inputs-wrapper">
            {title && <OliverText text={t("generalComponents.borderRadiusInputs." + title)} size="xs" />}
            <div className="radius-row">
                <div className="radius-wrapper">
                    <OliverImage src="/border-radius-top-left.svg" />
                    <UnitInput value={init.topLeft.value} unit={init.topLeft.unit} callback={topLeftCallback} />
                </div>
                <div className="radius-wrapper">
                    <OliverImage src="/border-radius-top-right.svg" />
                    <UnitInput value={init.topRight.value} unit={init.topRight.unit} callback={topRightCallback} />
                </div>
            </div>
            <div className="radius-row">
                <div className="radius-wrapper">
                    <OliverImage src="/border-radius-bottom-left.svg" />
                    <UnitInput value={init.bottomLeft.value} unit={init.bottomLeft.unit} callback={bottomLeftCallback} />
                </div>
                <div className="radius-wrapper">
                    <OliverImage src="/border-radius-bottom-right.svg" />
                    <UnitInput value={init.bottomRight.value} unit={init.bottomRight.unit} callback={bottomRightCallback} />
                </div>
            </div>
            <button onMouseDown={handleApplyAll}>{t("generalComponents.borderRadiusInputs.Apply All")}</button>
        </div>
    );
};

export default BorderRadiusInputs;
